import { render, staticRenderFns } from "./activity_data_statistics2.vue?vue&type=template&id=68875a90&scoped=true"
import script from "./activity_data_statistics2.vue?vue&type=script&lang=js"
export * from "./activity_data_statistics2.vue?vue&type=script&lang=js"
import style0 from "./activity_data_statistics2.vue?vue&type=style&index=0&id=68875a90&prod&lang=scss"
import style1 from "./activity_data_statistics2.vue?vue&type=style&index=1&id=68875a90&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68875a90",
  null
  
)

export default component.exports